<template>
    <div class="authentication_form_box safe-distance-top">
        <div class="scholar_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">期刊认证</div>
        </div>
        <div class="scholar_bottom">
            <p class="group_title">基本信息</p>
            <van-cell-group class="cell_group_box">
                <van-cell class="upload_box" :required="true" title="头像" center>
                    <template>
                        <van-image
                            class="upload_img"
                            round
                            width="37px"
                            height="37px"
                            :src="
                                periodical.periodicalLogo
                                    ? $global.imgUrl + periodical.periodicalLogo
                                    : require('@/assets/img/mobile-img/upload-default.png')
                            "
                            @click="preview(periodical.periodicalLogo)"
                        />
                        <van-uploader
                            :max-size="1 * 1024 * 1024"
                            :before-read="beforeRead"
                            :after-read="(file) => clzpAfterRead(file, 'periodicalLogo')"
                            @oversize="onOversize"
                        >
                            <van-icon class="upload_icon" name="arrow" />
                        </van-uploader>
                    </template>
                </van-cell>
                <van-cell
                    :required="true"
                    title="期刊名称"
                    :value="periodical.name | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'name',
                            label: '期刊名称',
                            ruleKey: 'name',
                        })
                    "
                    is-link
                />
                <van-cell class="upload_box" :required="true" title="封面" center>
                    <van-image
                        class="upload_img upload_img_card"
                        width="42px"
                        height="60px"
                        :src="
                            periodical.coverImg
                                ? $global.imgUrl + periodical.coverImg
                                : require('@/assets/img/mobile-img/zz_default.png')
                        "
                        @click="preview(periodical.coverImg)"
                    />
                    <van-uploader
                        :max-size="1 * 1024 * 1024"
                        :before-read="beforeRead"
                        :after-read="(file) => clzpAfterRead(file, 'coverImg')"
                        @oversize="onOversize"
                    >
                        <van-icon class="upload_icon" name="arrow" />
                    </van-uploader>
                </van-cell>
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell class="list_cell" :required="true" title="主管单位" center>
                    <template>
                        <div class="list_btn" @click="toAddList('responsibleDeptList')">添加</div>
                    </template>
                </van-cell>
                <van-cell
                    v-for="(item, index) in periodical.responsibleDeptList"
                    :key="index"
                    :title="'主管单位' + (index + 1)"
                    :value="item.orgName | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'responsibleDeptList.' + index + '.orgName',
                            label: '主管单位' + (index + 1),
                            ruleKey: 'name',
                            hasDeleteBtn: true,
                        })
                    "
                    is-link
                />
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell class="list_cell" :required="true" title="主办单位" center>
                    <template>
                        <div class="list_btn" @click="toAddList('organizerList')">添加</div>
                    </template>
                </van-cell>
                <van-cell
                    v-for="(item, index) in periodical.organizerList"
                    :key="index"
                    :title="'主办单位' + (index + 1)"
                    :value="item.orgName | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'organizerList.' + index + '.orgName',
                            label: '主办单位' + (index + 1),
                            ruleKey: 'name',
                            hasDeleteBtn: true,
                        })
                    "
                    is-link
                />
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell class="list_cell" :required="true" title="出版单位" center>
                    <template>
                        <div class="list_btn" @click="toAddList('publishCompanyList')">添加</div>
                    </template>
                </van-cell>
                <van-cell
                    v-for="(item, index) in periodical.publishCompanyList"
                    :key="index"
                    :title="'出版单位' + (index + 1)"
                    :value="item.orgName | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'publishCompanyList.' + index + '.orgName',
                            label: '出版单位' + (index + 1),
                            ruleKey: 'name',
                            hasDeleteBtn: true,
                        })
                    "
                    is-link
                />
            </van-cell-group>
            <van-cell-group class="cell_group_box">
                <van-cell
                    :required="true"
                    title="出版周期"
                    :value="publishPeriodText | isNull"
                    @click="periodPickerShow = true"
                    is-link
                />
                <van-popup
                    v-model="periodPickerShow"
                    position="bottom"
                    round
                    @opened="publishPopupOpen"
                >
                    <van-picker
                        ref="publishPickerRef"
                        show-toolbar
                        :columns="periodPickerColumns"
                        value-key="label"
                        @confirm="periodPickerConfirm"
                        @cancel="periodPickerShow = false"
                    />
                </van-popup>
                <van-cell
                    :required="true"
                    title="CN"
                    :value="periodical.cn | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'cn',
                            label: 'CN',
                            ruleKey: 'CN',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="ISSN"
                    :value="periodical.issn | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'issn',
                            label: 'ISSN',
                            ruleKey: 'CN',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="期刊分类"
                    :value="periodical.subject | isNull"
                    @click="subjectPickerShow = true"
                    is-link
                />
                <van-popup
                    v-model="subjectPickerShow"
                    position="bottom"
                    round
                    @opened="subjectPopupOpen"
                >
                    <van-picker
                        ref="subjectPickerRef"
                        show-toolbar
                        :columns="[{ values: qkOptions }, { values: qkSecondOptions }]"
                        value-key="label"
                        title="请选择期刊分类"
                        :loading="subjectLoading"
                        @cancel="subjectPickerShow = false"
                        @change="subjectPickerChange"
                        @confirm="subjectPickerConfirm"
                    />
                </van-popup>
                <van-cell
                    title="邮发代号"
                    :value="periodical.codeDomestic | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'codeDomestic',
                            label: '邮发代号',
                            ruleKey: 'codeDomestic',
                        })
                    "
                    is-link
                />
                <van-cell
                    title="创刊时间"
                    :value="periodical.foundedDate | isNull"
                    @click="datePickerShow = true"
                    is-link
                />
                <van-popup v-model="datePickerShow" position="bottom" round @opened="datePopupOpen">
                    <van-picker
                        ref="datePickerRef"
                        show-toolbar
                        :columns="datePickerColumns"
                        @cancel="datePickerShow = false"
                        @confirm="datePickerConfirm"
                    />
                </van-popup>
                <van-cell
                    title="出版地"
                    :value="
                        `${periodical.publishAddrProvince}-${periodical.publishAddrCity}` | isNull
                    "
                    @click="addrPickerShow = true"
                    is-link
                />
                <van-popup v-model="addrPickerShow" position="bottom" round @opened="addrPopupOpen">
                    <van-picker
                        ref="addrPickerRef"
                        show-toolbar
                        :columns="[{ values: provinceOptions }, { values: cityOptions }]"
                        value-key="label"
                        title="请选择出版地"
                        :loading="addrLoading"
                        @cancel="addrPickerShow = false"
                        @change="addrPickerChange"
                        @confirm="addrPickerConfirm"
                    />
                </van-popup>
                <van-cell
                    title="语种"
                    :value="languagePeriodText | isNull"
                    @click="languagePickerShow = true"
                    is-link
                />
                <van-popup
                    v-model="languagePickerShow"
                    position="bottom"
                    round
                    @opened="languagePopupOpen"
                >
                    <van-picker
                        ref="languagePickerRef"
                        show-toolbar
                        :columns="languagePickerColumns"
                        value-key="label"
                        @cancel="languagePickerShow = false"
                        @confirm="languagePickerConfirm"
                    />
                </van-popup>
                <van-cell
                    title="开本"
                    :value="periodical.format | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'format',
                            label: '开本',
                            ruleKey: 'length20',
                        })
                    "
                    is-link
                />
                <van-cell
                    title="E-mail"
                    :value="periodical.email | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodical',
                            key: 'email',
                            label: 'E-mail',
                            ruleKey: 'email',
                        })
                    "
                    is-link
                />
                <van-cell
                    title="收录数据库"
                    :value="periodical.coreName | isNull"
                    @click="corePopupShow = true"
                    is-link
                />
                <van-action-sheet v-model="corePopupShow" title="收录数据库" @open="corePopupOpen">
                    <div class="core-popup-box">
                        <van-checkbox-group v-model="coreArr">
                            <van-cell-group>
                                <van-cell
                                    v-for="(item, index) in coreList"
                                    clickable
                                    :key="item"
                                    :title="item"
                                    @click="coreToggle(index)"
                                >
                                    <template #right-icon>
                                        <van-checkbox :name="item" ref="coreCheckboxes" />
                                    </template>
                                </van-cell>
                            </van-cell-group>
                        </van-checkbox-group>
                        <van-button class="core-popup-btn" round type="info" @click="confirmCore"
                            >确定</van-button
                        >
                    </div>
                </van-action-sheet>
            </van-cell-group>
            <p class="group_title">账号管理员信息</p>
            <van-cell-group class="cell_group_box">
                <van-cell
                    :required="true"
                    title="姓名"
                    :value="periodicalInfo.operateName | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodicalInfo',
                            key: 'operateName',
                            label: '姓名',
                            ruleKey: 'adminUserName',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="身份证号"
                    :value="periodicalInfo.operateIdentityCard | isNull"
                    @click="
                        toEdit('InputEdit', {
                            objName: 'periodicalInfo',
                            key: 'operateIdentityCard',
                            label: '身份证号',
                            ruleKey: 'idNumber',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="上传身份证照片"
                    :value="periodicalInfo.operateIdentityImgFront | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'periodicalInfo',
                            key: 'operateIdentityImgFront,operateIdentityImgBack',
                            label: '身份证',
                        })
                    "
                    is-link
                />
            </van-cell-group>
            <p class="group_title">期刊资质信息</p>
            <van-cell-group class="cell_group_box">
                <van-cell
                    :required="true"
                    title="营业执照"
                    :value="periodicalInfo.businessLicense | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'periodicalInfo',
                            key: 'businessLicense',
                            label: '营业执照',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="期刊出版许可证"
                    :value="periodicalInfo.publicationLicense | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'periodicalInfo',
                            key: 'publicationLicense',
                            label: '期刊出版许可证',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="岗位培训证"
                    :value="periodicalInfo.jobsTrainingCertificate | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'periodicalInfo',
                            key: 'jobsTrainingCertificate',
                            label: '岗位培训证',
                        })
                    "
                    is-link
                />
                <van-cell
                    title="责任编辑证"
                    :value="periodicalInfo.advertiseLicense | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'periodicalInfo',
                            key: 'advertiseLicense',
                            label: '责任编辑证',
                        })
                    "
                    is-link
                />
                <van-cell
                    title="广告经营许可证"
                    :value="periodicalInfo.dutyCompilerCertificate | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'periodicalInfo',
                            key: 'dutyCompilerCertificate',
                            label: '广告经营许可证',
                        })
                    "
                    is-link
                />
            </van-cell-group>
        </div>
        <div class="submit_btn">
            <van-button
                class="form_btn"
                round
                block
                type="info"
                native-type="submit"
                :loading="submitLoding"
                @click="submitAuthentication"
                >提交</van-button
            >
        </div>
    </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
export default {
    name: "PeriodicalAuthentication",
    data() {
        return {
            periodical: {
                periodicalLogo: "",
                name: "",
                coverImg: "",
                responsibleDeptList: [],
                organizerList: [],
                publishCompanyList: [],
                publishPeriod: "",
                cn: "",
                issn: "",
                subject: "",
                subjectId: "",
                codeDomestic: "",
                foundedDate: "",
                publishAddrProvince: "",
                publishAddrCity: "",
                languageType: "",
                format: "",
                email: "",
                coreName: "",
            },
            periodicalInfo: {
                operateName: "",
                operateIdentityCard: "",
                operateIdentityImgFront: "",
                operateIdentityImgBack: "",
                businessLicense: "",
                publicationLicense: "",
                jobsTrainingCertificate: "",
                advertiseLicense: "",
                dutyCompilerCertificate: "",
            },
            publishPeriodText: "",
            periodPickerShow: false,
            periodPickerColumns: [
                { label: "年刊", value: 1 },
                { label: "半年刊", value: 2 },
                { label: "季刊", value: 3 },
                { label: "双月刊", value: 4 },
                { label: "月刊", value: 5 },
                { label: "半月刊", value: 6 },
                { label: "旬刊", value: 7 },
                { label: "周刊", value: 8 },
                { label: "周二刊", value: 9 },
            ],
            subjectPickerShow: false,
            subjectLoading: false,
            qkOptions: [],
            qkSecondOptions: [],
            datePickerShow: false,
            datePickerColumns: [],
            addrLoading: false,
            addrPickerShow: false,
            provinceOptions: [],
            cityOptions: [],
            languagePickerShow: false,
            languagePickerColumns: [
                { label: "中文", value: 1 },
                { label: "英文", value: 2 },
                { label: "其他", value: 3 },
            ],
            languagePeriodText: "",
            coreList: [],
            corePopupShow: false,
            coreArr: [],
            submitLoding: false,
        };
    },
    created() {
        if (sessionStorage.getItem("periodical") || sessionStorage.getItem("periodicalInfo")) {
            this.formateInfo();
        } else {
            this.getUserDetails();
        }
        this.datePickerColumns = this.getYears();
        this.getPeriodicalList();
        this.getAddrOptionsList();
        this.getIncludeList();
    },
    watch: {
        periodical: {
            handler(newV) {
                sessionStorage.setItem("periodical", JSON.stringify(newV));
            },
            deep: true,
        },
        periodicalInfo: {
            handler(newV) {
                sessionStorage.setItem("periodicalInfo", JSON.stringify(newV));
            },
            deep: true,
        },
    },
    filters: {
        isNull(value) {
            return value && value !== "" && value !== "-" ? value : "未设置";
        },
        isImgNull(value) {
            return value !== "" ? "已上传" : "未设置";
        },
    },
    methods: {
        // 获取基本信息
        async getUserDetails() {
            let res = await this.$apis.userServe.getMaDetails();
            if (res.data && res.data.auth && res.data.auth.jsonDataObj) {
                let periodical = res.data.auth.jsonDataObj.periodical;
                let periodicalInfoObj = res.data.auth.jsonDataObj.periodicalInfo;
                sessionStorage.setItem("periodical", JSON.stringify(periodical));
                sessionStorage.setItem("periodicalInfo", JSON.stringify(periodicalInfoObj));
                this.formateInfo();
            }
        },
        formateInfo() {
            if (sessionStorage.getItem("periodical")) {
                let periodical = JSON.parse(sessionStorage.getItem("periodical"));
                for (const key in periodical) {
                    if (key === "publishPeriod" && periodical[key] !== "") {
                        this.publishPeriodText = this.periodPickerColumns.filter(
                            (item) => item.value == periodical[key]
                        )[0].label;
                    } else if (key === "languageType" && periodical[key] !== "") {
                        this.languagePeriodText = this.languagePickerColumns.filter(
                            (item) => item.value == periodical[key]
                        )[0].label;
                    }
                    this.periodical[key] = periodical[key];
                }
            }
            if (sessionStorage.getItem("periodicalInfo")) {
                let periodicalInfo = JSON.parse(sessionStorage.getItem("periodicalInfo"));
                for (const key in periodicalInfo) {
                    this.periodicalInfo[key] = periodicalInfo[key];
                }
            }
        },
        to() {
            if (this.$route.query.out) {
                // 有out代表是APP进入
                if (this.$global.isAndroid_ios()) {
                    window.android.gubeit();
                } else {
                    window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
                }
                return;
            }
            this.$router.go(-1);
            sessionStorage.removeItem("periodical");
            sessionStorage.removeItem("periodicalInfo");
        },
        // 预览上传的图片
        preview(url) {
            if (url) {
                ImagePreview({
                    images: [this.$global.imgUrl + url],
                    closeable: true,
                });
            }
        },
        //校验上传图片大小
        onOversize(file) {
            Toast("文件大小不能超过1MB");
        },
        //校验图片的格式
        beforeRead(file) {
            if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
                Toast("仅支持JPG、JPEG、PNG格式");
                return false;
            }
            return true;
        },
        //照片上传事件方法
        async clzpAfterRead(file, key) {
            // 创建一个空对象实例
            let formData = new FormData();
            // 调用append()方法添加数据
            formData.append("file", file.file);
            const res = await this.$apis.myServe.uploadFileMannual(formData);
            this.periodical[key] = res.data;
            // sessionStorage.setItem("subInfo", JSON.stringify(this.subInfo));
        },
        // 去编辑
        toEdit(path, query) {
            console.log(path, query);
            this.$router.push({ path, query });
        },
        // 增加单位列表
        toAddList(key) {
            if (this.periodical[key].length < 5) {
                this.periodical[key].push({ orgName: "" });
            } else {
                Toast("最多能添加5条");
            }
        },
        publishPopupOpen() {
            if (this.periodical.languageType) {
                this.$refs.publishPickerRef.setValues([this.publishPeriodText]);
            }
        },
        periodPickerConfirm({ value, label }) {
            this.periodical.publishPeriod = value;
            this.publishPeriodText = label;
            this.periodPickerShow = false;
        },
        // 获取期刊分类
        async getPeriodicalList() {
            this.subjectLoading = true;
            const { perClaOneList } = await this.$apis.hundredServe.getPerOneList();
            this.qkOptions = perClaOneList.map((item) => ({ label: item.name, value: item.code }));
            let chiefSubjectId = this.periodical.subjectId
                ? this.periodical.subjectId.slice(0, 2)
                : this.qkOptions[0].value;
            this.getPeriodicalSecondList(chiefSubjectId);
            this.subjectLoading = false;
        },
        async getPeriodicalSecondList(parentCode) {
            this.subjectLoading = true;
            const { perClaTwoList } = await this.$apis.hundredServe.getListByParentCode({
                parentCode,
            });
            this.qkSecondOptions = perClaTwoList.map((item) => ({
                label: item.name,
                value: item.code,
            }));
            this.subjectLoading = false;
        },
        subjectPopupOpen() {
            if (this.periodical.subjectId) {
                this.subjectLoading = true;
                let chiefSubjectId = this.periodical.subjectId.slice(0, 2);
                let firstIndex = this.qkOptions.findIndex((item) => item.value === chiefSubjectId);
                let secondIndex = this.qkSecondOptions.findIndex(
                    (item) => item.value === this.periodical.subjectId
                );
                this.$refs.subjectPickerRef.setColumnIndex(0, firstIndex);
                this.$refs.subjectPickerRef.setColumnIndex(1, secondIndex);
                this.subjectLoading = false;
            }
        },
        async subjectPickerChange(_, values, index) {
            if (index === 0) {
                this.getPeriodicalSecondList(values[0].value);
            }
        },
        subjectPickerConfirm(values) {
            if (values.every((item) => item !== undefined)) {
                this.periodical.subject = values[1].label;
                this.periodical.subjectId = values[1].value;
                this.subjectPickerShow = false;
            }
        },
        getYears() {
            //获取当前时间
            let nowYears = new Date().getFullYear();
            let arrYear = [];
            for (let i = 0; i <= 100; i++) {
                arrYear.push(nowYears--);
            }
            return arrYear;
        },
        datePopupOpen() {
            if (this.periodical.foundedDate) {
                this.$refs.datePickerRef.setValues([this.periodical.foundedDate]);
            }
        },
        datePickerConfirm(value) {
            console.log(value);
            this.periodical.foundedDate = value;
            this.datePickerShow = false;
        },
        // 获取出版地
        async getAddrOptionsList() {
            this.addrLoading = true;
            const proVinceRes = await this.$apis.userServe.proList();
            this.provinceOptions = proVinceRes.content.provinceList.map((item) => ({
                label: item.name,
                value: item.code,
            }));
            let provinceCode = this.provinceOptions[0].value;
            if (this.periodical.publishAddrProvince) {
                let chooseProvince = this.provinceOptions.filter(
                    (item) => item.label === this.periodical.publishAddrProvince
                );
                provinceCode = chooseProvince[0].value;
            }
            this.getAddrSecondOptionsList(provinceCode);
            this.addrLoading = false;
        },
        async getAddrSecondOptionsList(provinceCode) {
            this.addrLoading = true;
            const cityRes = await this.$apis.userServe.cityList({ provinceCode });
            this.cityOptions = cityRes.content.cityList.map((item) => ({
                label: item.name,
                value: item.code,
            }));
            this.addrLoading = false;
        },
        addrPopupOpen() {
            if (this.periodical.publishAddrProvince && this.periodical.publishAddrCity) {
                this.addrLoading = true;
                this.$refs.addrPickerRef.setColumnValue(0, this.periodical.publishAddrProvince);
                this.$refs.addrPickerRef.setColumnValue(1, this.periodical.publishAddrCity);
                this.addrLoading = false;
            }
        },
        async addrPickerChange(_, values, index) {
            if (index === 0) {
                this.getAddrSecondOptionsList(values[0].value);
            }
        },
        addrPickerConfirm(values) {
            if (values.every((item) => item !== undefined)) {
                this.periodical.publishAddrProvince = values[0].label;
                this.periodical.publishAddrCity = values[1].label;
                this.addrPickerShow = false;
            }
        },
        languagePopupOpen() {
            if (this.periodical.languageType) {
                this.$refs.languagePickerRef.setValues([this.languagePeriodText]);
            }
        },
        languagePickerConfirm({ value, label }) {
            this.periodical.languageType = value;
            this.languagePeriodText = label;
            this.languagePickerShow = false;
        },
        async getIncludeList() {
            const res = await this.$apis.searchServe.getIncludeList();
            console.log(res, "res");
            this.coreList = res.dbList.map((item) => item.dbName);
        },
        coreToggle(index) {
            this.$refs.coreCheckboxes[index].toggle();
        },
        corePopupOpen() {
            console.log(this.periodical.coreName, "this.periodical.coreName");
            if (this.periodical.coreName !== "") {
                this.coreArr = this.periodical.coreName.split(",");
            }
            console.log(this.coreArr);
        },
        confirmCore() {
            this.periodical.coreName = this.coreArr.join();
            this.corePopupShow = false;
        },
        async submitAuthentication() {
            this.submitLoding = true;
            let basicInfoStrValidate = [
                "periodicalLogo",
                "name",
                "coverImg",
                "publishPeriod",
                "cn",
                "issn",
                "subject",
                "subjectId",
            ].every((item) => this.periodical[item] !== "");
            let basicInfoListValidate = [
                "responsibleDeptList",
                "organizerList",
                "publishCompanyList",
            ].every(
                (item) =>
                    this.periodical[item].length > 0 &&
                    this.periodical[item].every((i) => i.orgName !== "")
            );
            let basicInfoVerify = basicInfoStrValidate && basicInfoListValidate;
            let managerVerify = [
                "operateName",
                "operateIdentityCard",
                "operateIdentityImgFront",
                "operateIdentityImgBack",
            ].every((item) => this.periodicalInfo[item] !== "");
            let certificationVerify = [
                "businessLicense",
                "publicationLicense",
                "jobsTrainingCertificate",
            ].every((item) => this.periodicalInfo[item] !== "");
            if (basicInfoVerify) {
                if (managerVerify) {
                    if (certificationVerify) {
                        console.log(this.periodical, "periodical");
                        console.log(this.periodicalInfo, "periodicalInfo");
                        const { data } = await this.$apis.userServe.subPeriodical({
                            periodical: this.periodical,
                            periodicalInfo: this.periodicalInfo,
                        });
                        if (data.resultCode !== "200") {
                            Toast(data.resultDesc);
                        } else {
                            Toast("提交成功");
                            sessionStorage.removeItem("periodical");
                            sessionStorage.removeItem("periodicalInfo");
                            this.$router.push({
                                path: "/scholarStatus",
                                query: { title: "期刊认证" },
                            });
                        }
                    } else {
                        Toast("请填写期刊资质信息中必填字段");
                    }
                } else {
                    Toast("请填写账号管理员信息中必填字段");
                }
            } else {
                Toast("请填写基本信息中必填字段");
            }
            this.submitLoding = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.authentication_form_box {
    position: relative;
    padding-bottom: 50px;
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .scholar_top {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        line-height: 44px;
        background: #fff;
    }

    .my {
        font-size: 18px;
        color: #333333;
    }

    .scholar_bottom {
        margin: 22px auto;
        padding-bottom: 20px;
        width: 94%;
        height: 100%;

        .group_title {
            margin: 22px 0 12px;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
        }

        .cell_group_box {
            margin-top: 12px;
            border-radius: 8px;
            overflow: hidden;

            .upload_box {
                .upload_img {
                    margin-right: 10px;
                    vertical-align: middle;
                }

                .upload_img_card {
                    border-radius: 5px;
                    overflow: hidden;
                }

                .upload_icon {
                    height: 24px;
                    font-size: 16px;
                    line-height: 24px;
                    color: #969799;
                    vertical-align: middle;
                }
            }

            .list_cell {
                .list_btn {
                    font-size: 14px;
                    color: #4a79f1;
                    line-height: 14px;
                }
            }
        }
    }

    .submit_btn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 5px 15px 0;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 10px) !important;
        padding-bottom: calc(env(safe-area-inset-bottom) + 10px) !important;
        background-color: #fff;

        .form_btn {
            width: 100%;
            height: 44px;
            background: #4a79f1;
            border-radius: 22px;
        }
    }

    .core-popup-box {
        .core-popup-btn {
            display: block;
            margin: 10px auto;
            width: 80%;
        }
    }
}
</style>
